var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoldierLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 27,
    viewBox: "0 0 18 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9997 9.85499V10.2715C17.9997 10.2715 18.0428 11.5499 17.3103 11.5499C16.8075 11.5499 16.0176 10.961 15.3425 10.4439C15.3425 10.4942 15.3496 10.5408 15.3568 10.5875C15.364 10.6342 15.3712 10.6809 15.3712 10.7312C15.3712 14.1353 12.6135 16.893 9.20936 16.893C5.80525 16.893 3.04747 14.1353 3.04747 10.7312C3.04747 10.6809 3.05464 10.6342 3.06184 10.5875C3.06904 10.5408 3.07622 10.4942 3.07622 10.4439L3.06544 10.4521C2.40697 10.9531 1.62269 11.5499 1.10844 11.5499C0.361555 11.5499 0.418989 10.2715 0.418989 10.2715V9.85499C0.418989 8.55976 0.887068 7.94458 1.22764 7.49695C1.32139 7.37373 1.4055 7.26321 1.46751 7.15469C1.52672 7.05106 1.63658 6.79546 1.78679 6.44601C2.36531 5.10023 3.54213 2.36258 4.72801 1.553C6.20741 0.533203 9.20936 0.533203 9.20936 0.533203C9.20936 0.533203 12.1969 0.533203 13.6907 1.553C14.8652 2.35119 16.0487 5.09566 16.6304 6.44465C16.7815 6.7949 16.892 7.05107 16.9512 7.15469C17.0154 7.27033 17.1033 7.38668 17.2012 7.51612C17.5408 7.9655 17.9997 8.5726 17.9997 9.85499ZM1.00465 21.1299C5.11256 19.1334 9.20613 19.1621 9.20613 19.1621H9.19734C9.36775 19.1624 13.3873 19.1902 17.3932 21.1299V26.4156H1.00465V21.1299Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoldierLogo);
export default __webpack_public_path__ + "static/media/soldier-logo.97e09436fce80fa888b6a1c8ad2aecec.svg";
export { ForwardRef as ReactComponent };